interface AddCommentParams {
  recipeId: string;
  authorId: number | null | undefined;
  token: string | null;
  comment: string;
  addComment: (payload: {
    recipe_id: string;
    author_id: number;
    comment: string;
  }) => Promise<unknown>;
}

interface AddCommentResult {
  shouldAbort: boolean;
  error?: string;
  shouldResetComment?: boolean;
}

export const readAddCommentErrorMessage = (error: unknown): string => {
  if (
    error &&
    typeof error === 'object' &&
    'message' in error &&
    typeof error.message === 'string' &&
    error.message
  ) {
    return error.message;
  }

  return 'Failed to add comment.';
};

export const canSubmitComment = (
  comment: string,
  authorId: number | null | undefined,
  token: string | null
) => Boolean(comment.trim() && authorId && token);

export const submitRecipeComment = async ({
  recipeId,
  authorId,
  token,
  comment,
  addComment,
}: AddCommentParams): Promise<AddCommentResult> => {
  if (!canSubmitComment(comment, authorId, token)) {
    return { shouldAbort: true };
  }

  try {
    await addComment({
      recipe_id: recipeId,
      author_id: authorId!,
      comment,
    });

    return {
      shouldAbort: false,
      shouldResetComment: true,
    };
  } catch (error) {
    return {
      shouldAbort: true,
      error: readAddCommentErrorMessage(error),
    };
  }
};
